import React from "react";
import "./HeroHome.scss"
import hero from "../../assets/images/hero.png"
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import { setOrderData, setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import { updateOrderTypeDetails } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import deliveryIc from "../../assets/delivery-cycle.svg"
import collectionIC from "../../assets/shop.svg"
const HeroHome = ({ setCollectionStore, setAddDeliveryLoc }) => {

    const dispatch = useDispatch()
    const { selectedOrderType } = useSelector((state) => state.resturantData);
    const { companies } = useSelector((state) => state.companyData);
    const company = useSelector((state) => state.companyData.company);
    const storeClosed = useSelector((state) => state.companyData.storeClosed);

    const orderTypes = [
        { name: "Collection", type: "collection", typeValue: "TAKE_AWAY" },
        // { name: "Dine-in", type: "table", typeValue: "DINE_IN" },
        { name: "Delivery", type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },

    ]
    const filteredData = () => {
        const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes
        const val = orderTypes.filter(item => availableTypes?.includes(item.type));
        return val
    }
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }
    return (
        <div className="HeroHome"
            style={{
                backgroundImage: ` linear-gradient(180deg, rgba(16, 24, 40, 0.8) 0%, rgba(16, 24, 40, 0.5) 50%, rgba(16, 24, 40, 0.9) 100%)
, url(${hero})`
            }} >
            <div className="HeroHome-tag">Welcome to</div>
            <div className="HeroHome-header">Legends the Sandwich shop</div>
            <div className="HeroHome-sub">Food & Drinks Menu</div>
            {selectedOrderType !== "table" && <div className='HeroHome-type-selection'>
                {filteredData().map((orderType, index) => {
                    return (
                        <div key={index} className={`HeroHome-type-selection-type ${selectedOrderType === orderType.type ? "HeroHome-type-selection-type-selected" : ""} `}


                            onClick={() => {

                                if (orderType.type === "delivery") {
                                    setAddDeliveryLoc(true)
                                } else {
                                    if (companies.length > 1) {
                                        setCollectionStore(true)
                                    } else {
                                        updateOrderType(orderType.typeValue)
                                        localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_STR_LOC_ID, company.LocationID)
                                        dispatch(setSelectedOrderType(orderType.type))
                                        localStorage.removeItem("schedule_order")
                                    }
                                }
                            }}>
                            <img alt='' src={orderType.type === "collection" ? collectionIC : deliveryIc} className='selection-type-icon' />

                            {orderType.name}{storeClosed[orderType.type] && <div className='order-close'>Closed</div>}</div>
                    )
                })}
            </div>}
        </div>
    )
}
export default HeroHome